import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useMemo } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectorSegmentos } from '../../../../../../reducers/gerenciadorPrecos/segmentos';
import categorySchema, { CategoryLevels } from '../lib/schema';
import { useCategoryLevelsQuery } from './useCategoryLevelsQuery';

export const useCategoryLevels = () => {
  const segments = useSelector(selectorSegmentos);
  const queriesCategoryLevels = useCategoryLevelsQuery();

  const formatedSegments = useMemo(() => {
    return (queriesCategoryLevels.queriesData?.queryLevels || segments).map(seg => {
      return { ...seg, label: `${seg.level} - ${seg.label}` };
    });
  }, [queriesCategoryLevels.queriesData?.queryLevels, segments]);

  const form = useForm<CategoryLevels>({
    resolver: zodResolver(categorySchema),
    defaultValues: {
      categoryLevels: formatedSegments || [],
    },
    mode: 'onSubmit',
  });

  const { fields } = useFieldArray({
    control: form.control,
    name: 'categoryLevels',
  });

  useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name?.includes('categoryLevels.') && type === 'change') {
        const categoryLevels = value.categoryLevels;

        if (!categoryLevels?.length) return;
        form.setValue(
          'categoryLevels',
          categoryLevels.map(cat => ({
            name: cat?.name ?? '',
            level: cat?.level ?? 0,
            field: cat?.field ?? '',
            label: cat?.label ?? '',
            value: cat?.value ?? '',
          })),
        );
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  useEffect(() => {
    form.reset({
      categoryRoleCalculation: queriesCategoryLevels.queriesData?.queryCategoryRole || formatedSegments[2],
      objectiveMargin: queriesCategoryLevels.queriesData?.queryObjetiveMargin || formatedSegments[2],
      categoryLevels: formatedSegments || [],
    });
  }, [form, formatedSegments, queriesCategoryLevels.queriesData?.queryCategoryRole, queriesCategoryLevels.queriesData?.queryObjetiveMargin]);

  useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name?.includes('categoryLevels.') && type === 'change') {
        const categoryLevels = value.categoryLevels;

        if (!categoryLevels?.length) return;
        form.setValue(
          'categoryLevels',
          categoryLevels.map(cat => ({
            name: cat?.name ?? '',
            level: cat?.level ?? 0,
            field: cat?.field ?? '',
            label: cat?.label ?? '',
            value: cat?.value ?? '',
          })),
        );
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  useEffect(() => {
    const defaultLevel = formatedSegments[2];
    form.reset({
      categoryRoleCalculation: queriesCategoryLevels.queriesData?.queryCategoryRole || defaultLevel,
      objectiveMargin: queriesCategoryLevels.queriesData?.queryObjetiveMargin || defaultLevel,
      categoryLevels: formatedSegments || [],
      optimizationCategory: queriesCategoryLevels.queriesData?.queryOptimizationCategory || defaultLevel,
    });
  }, [
    form,
    formatedSegments,
    queriesCategoryLevels.queriesData?.queryCategoryRole,
    queriesCategoryLevels.queriesData?.queryObjetiveMargin,
    queriesCategoryLevels.queriesData?.queryOptimizationCategory,
  ]);

  return useMemo(() => ({ queriesCategoryLevels, fields, form }), [queriesCategoryLevels, fields, form]);
};
